import { observer } from "mobx-react-lite";
import { Outlet } from "react-router-dom";
import { PageContainer } from "share-components/templates/page/page-container";

export const DeliveryNote = observer(() => {
  return (
    <PageContainer>
      <Outlet></Outlet>
    </PageContainer>
  );
});
